import { useTranslation } from "react-i18next";
import { FORT_AGENT_STATUS, MyFortAgentItem } from "@/api/types";
import { C } from "@/components/modal/home";
import { MyAgentCard } from "./MyAgentCard";
import { MyAgentsDialogsHost } from "./MyAgentsDialogsHost";
import { MyAgentsSectionSkeleton } from "./MyAgentsSectionSkeleton";

export type MyAgentsSectionBodyProps = {
  myAgentsLoading: boolean;
  agents: MyFortAgentItem[] | undefined;
  onAddress: () => void;
  onTransfer: (agent: MyFortAgentItem) => void;
};

/** 「我的智能体」独立页：列表 / 空态 / 加载态 */
export function MyAgentsSectionBody({
  myAgentsLoading,
  agents,
  onAddress,
  onTransfer,
}: MyAgentsSectionBodyProps) {
  const { t } = useTranslation();

  if (myAgentsLoading) {
    return <MyAgentsSectionSkeleton />;
  }

  const agentList = agents ?? [];

  if (agentList.length === 0) {
    return (
      <div
        className="rounded-2xl flex flex-col items-center justify-center py-14 gap-2"
        style={{
          background:
            "linear-gradient(135deg, rgba(100,140,200,0.015) 0%, #0c1020 40%, #080c18 100%)",
          border: "1px solid rgba(100,140,200,0.06)",
        }}
      >
        <p className="text-sm font-medium" style={{ color: C.muted }}>
          {t("homePage.myAgents.emptyTitle")}
        </p>
        <p className="text-xs" style={{ color: C.dim }}>
          {t("homePage.myAgents.emptySubtitle")}
        </p>
      </div>
    );
  }

  const hasActivatedAgent = agentList.some(
    a => a.status === FORT_AGENT_STATUS.ACTIVATED
  );

  return (
    <>
      <div className="space-y-3">
        {agentList.map(agent => (
          <MyAgentCard
            key={agent.agentId}
            agent={agent}
            onAddress={onAddress}
            onTransfer={() => onTransfer(agent)}
            hasActivatedAgent={hasActivatedAgent}
          />
        ))}
      </div>
      <MyAgentsDialogsHost agents={agentList} />
    </>
  );
}
